export default __webpack_public_path__ + "static/TTNormsProRegular-2b54d15119f527397c2ef5f684d698a4.woff2";